import React from 'react'
import { GatsbyProvider } from './src/context'
import { GlobalStyle, NormalizeStyle } from './src/components/styles'
import Layout from './src/components/Layout'

export const wrapRootElement = ({ element }) => {
  return (
    <GatsbyProvider>
      <NormalizeStyle />
      <GlobalStyle />
      <Layout>{element}</Layout>
    </GatsbyProvider>
  )
}
